export default class CBAA1010RequestModel {}
